import { isMobileLayout } from 'components/Shared/responsive';
import { FilterDesktop } from '../BGH-RD3/desktop';
import { FilterMobile } from './filterMobile';
import connect from 'components/Shared/connect';
import { forwardRef, Ref } from 'react';

interface MergedProps {
  isMobileLayout: boolean;
  webCatalog: string;
}

export const Filter = connect<MergedProps>(
  state => ({
    isMobileLayout: isMobileLayout(state),
    webCatalog: state.currentPage.webCatalog
  }),
  undefined,
  undefined,
  { forwardRef: true }
)(
  forwardRef(({ isMobileLayout, webCatalog }: MergedProps, ref: Ref<HTMLDivElement>) => {
    return isMobileLayout ? (
      <FilterMobile key={webCatalog} ref={ref} />
    ) : (
      <FilterDesktop key={webCatalog} ref={ref} />
    );
  })
);
